import { lazy, Suspense } from 'react'
import AddLogModal from '../../../../components/modals/AddLogModal'
import useStructuredLogsFlag from '../useStructuredLogsFlag'

const StructuredLogModal = lazy(() => import('./StructuredLogModal'))
const EditStructuredLogModal = lazy(
  () => import('../../../../components/modals/EditStructuredLogModal')
)
const EditLogDetailsModal = lazy(
  () => import('../../../../components/modals/EditLogDetailsModal')
)

const LogModalSwitch = () => {
  const structuredLogs = useStructuredLogsFlag()
  if (structuredLogs.isLoading) return null
  return structuredLogs.enabled ? (
    <Suspense fallback={null}>
      <StructuredLogModal />
      <EditStructuredLogModal />
      <EditLogDetailsModal />
    </Suspense>
  ) : (
    <AddLogModal />
  )
}

export default LogModalSwitch
